import React, {Component} from 'react';
//import TestData from './data'
import TableFilter from '../TableFilter'
import ComandiServerTable from './ComandiServerTable'
import ErrorMessage from '../ErrorMessage'
import OkMessage from '../OkMessage'
import {client} from '../../Client';
import {copiaTestoNegliAppunti, createInstance} from '../../Helpers';
import PropTypes from 'prop-types';

class ComandiServerList extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {},
            filterInfo: {
            },
            _loading: false,
            error: null,
            executionCommand: null,
            command: null
        };
        this.storeInstance = createInstance();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.loadData = this.loadData.bind(this)
        this.onExecuteCommand = this.onExecuteCommand.bind(this)
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('comandiserverlist', this , () => {
                this.loadData(1,  this.state.orderInfo, this.state.filterInfo);
            }) === null){
            this.loadData(1,  this.state.orderInfo, this.state.filterInfo);
        }
    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('comandiserverlist', this.state);
        }
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeFilter(data){
        let newFilterInfo = Object.assign(this.state.filterInfo, data);
        this.loadData(1, this.state.orderInfo, newFilterInfo)
    }

    onExecuteCommand(ev, comando){
        this.setState({_loading: true})
        client.comandiServerExecute(comando).then(
            (response) => {

                if (response.ok){
                    this.setState({_loading: false, error: null, executionCommand: true, command: comando});

                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                            executionCommand: false, command: comando
                        });
                    });
                }
            }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadComandiServerList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    render() {

        if (this.state.error != null && this.state.executionCommand == null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null, executionCommand:null})}} />)
        }
        if (this.state.error != null && this.state.executionCommand != null && this.state.executionCommand === false)
        {
            return (<ErrorMessage title={'Esecuzione del comando fallita: ' + this.state.command.nome} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null, executionCommand:null})}} />)
        }

        let okMsg = null;

        if (this.state.executionCommand != null && this.state.executionCommand === true)
        {
            return (<OkMessage title="Esecuzione del comando effettuata con successo!" msg={this.state.command.nome} onDismiss={()=>{this.setState({error:null, executionCommand:null})}} />);
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui">

            <h3 className="ui top block attached header">
                <div className="ui green label">{this.state.total}</div> Comandi soddisfano i filtri specificati
            </h3>
            <div className="ui attached segment">
                <div className="ui two column grid">
                    <div className="eight wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra comando per nome, descrizione, comando..."
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                </div>
            </div>
            {okMsg}
            <ComandiServerTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                rowperpage={this.rowperpage}
                onChangePage={this.onChangePage}
                onExecuteCommand={this.onExecuteCommand}
            />
            {loader}
        </div>)
    }
}

ComandiServerList.contextTypes = {
    router: PropTypes.object
}

export default ComandiServerList;




/** WEBPACK FOOTER **
 ** ./src/components/configurazione/ComandiServerList.js
 **/